import { Link, useNavigate } from 'react-router-dom';
import { CaretIcon, CartIcon2, HomeIcon2, LocationIcon, OpenXLogo, SearchIcon2 } from '../../assets';
import styles from './style.module.css';
import { burger, PlaceHolderProfile } from '../../assets/svgs';
import FlatButtons from '../FlatButton/FlatButton';
import Typography from '../Typography/Typography';
import { useEffect, useState } from 'react';
import { BurgerMenu } from '../BurgerMenu';
import { useGetStoreByOwnerQuery } from '../../redux/services/storesApi';

export const NavBarMarketPlace = () => {
  const [isSearching, setIsSearching] = useState('');
  const [burgerToggle, setBurgerToggle] = useState(false)
  const { data, isLoading, isError } = useGetStoreByOwnerQuery();
  const [hasStore, setStoreAvailable] = useState(false)
  const navigate = useNavigate()
  

    useEffect(() => {
      if (!isLoading && !isError) 
      {
        setStoreAvailable(data && data.length > 0 ? true : false);
        console.log("Store Available");
      }
    }, [data, isLoading, isError]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsSearching(e.target.value);
  };

  const handleSearch = () => {
    console.log(isSearching);
  };

  const handleButtonClick = () =>
  {
    // window.location.href = '/create-store';
    navigate('/create-store')
  }
  // console.log("Toggle:", burgerToggle)

  return (
    <header className={styles.container}>
      <Link to="/marketPlace" className={styles.logo}>
        <OpenXLogo className={styles.logo} />
      </Link>

      <div className={styles.search}>
        <div className={styles.location}>
          <LocationIcon />
          Location
          <CaretIcon />
        </div>

        <input
          title="text"
          value={isSearching}
          onChange={handleSearchChange}
          type="text"
          className={styles.searchInput}
        />

        <div
          onClick={() => {
            handleSearch();
          }}
          className={styles.searchbtn}
        >
          <SearchIcon2 />
        </div>
      </div>

      <div className={styles.btnCont}>
        <Link to={'/marketplace'}>
          <HomeIcon2 color="black" />
        </Link>
        <Link to={'/buyer-cart'}>
          <CartIcon2 color="black" />
        </Link>

        <Link className={styles.profImg} to="/buyer-profile">
          <img src={PlaceHolderProfile} alt="" />
        </Link>

        <div className={styles.buttonGroup}>
          <FlatButtons
            onClick={() => {
              handleButtonClick()
            }}
            className={styles.primaryButton}
          >
            <Typography variant="buttonText" fontFamily="satoshi" weight="regular" size="base" className={styles.primaryButtonText}>
              Become a Seller
            </Typography>
          </FlatButtons>
        </div>
      </div>
      {!burgerToggle ?
        (
          <div
            onClick={() => { setBurgerToggle(!burgerToggle) }}
            className={styles.burgerIcon}
          >
            <img src={burger} alt="" />
          </div>
        ) :
        (
          // <div className={styles.buttonGroup}>
            <FlatButtons
              onClick={() => {
                // window.location.href = '/create-store';
                navigate('/create-store')
              }}
              className={styles.primaryButton}
            >
              <Typography variant="buttonText" fontFamily="satoshi" weight="regular" size="base" className={styles.primaryButtonText}>
                Become a Seller
              </Typography>
            </FlatButtons>
          // </div>
        )}


      <BurgerMenu open={burgerToggle} toggle={() => { setBurgerToggle(!burgerToggle) }} />

    </header>
  );
};